import { Component } from "@angular/core";

@Component({
    template: `<router-outlet></router-outlet>`
})

export class BlankLayoutComponent { }



// WEBPACK FOOTER //
// C:/WORK/Projects/ActNow_NG2/src/app/layout/blank-layout/blank-layout.component.ts